import type { Template } from "@/types";

export const PO_02_H2_V0: Template[] = [
    {
        id: "po-02-h2v0-01",
        name: "PO 01 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 199, width: 622, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 630, y: 199, width: 622, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-02",
        name: "PO 02 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 45, y: 226, width: 538, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 671, y: 226, width: 538, height: 333, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-03",
        name: "PO 03 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 75, y: 226, width: 548, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 630, y: 226, width: 548, height: 333, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-04",
        name: "PO 04 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 40, y: 226, width: 548, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 734, y: 268, width: 408, height: 248, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-05",
        name: "PO 05 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 109, y: 268, width: 408, height: 248, rotation: 0, imageRotation: 0 },
            { id: "2", x: 664, y: 226, width: 548, height: 333, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-06",
        name: "PO 06 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_06.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 45, y: 407, width: 538, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 671, y: 407, width: 538, height: 333, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h2v0-07",
        name: "PO 07 - H2V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h2_v0_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 734, y: 268, width: 408, height: 248, rotation: 0, imageRotation: 0 },
            { id: "2", x: 108, y: 268, width: 408, height: 248, rotation: 0, imageRotation: 0 }
        ],
    }
];